import type { ApiClient } from './runtime/apiRuntime';
import { apiMutationOptions, BaseApiMutationOptions } from './apiMutationOptions';
import { apiQueryOptions, BaseApiQueryOptions } from './apiQueryOptions';

export const FollowUpApi = {
    get: (webinarId: string, options?: BaseApiQueryOptions) => apiQueryOptions(['followUp', 'get', webinarId], (api) => api.followUp.get(webinarId), options),
    getById: (data: { webinarId: string; followUpId: string }, options?: BaseApiQueryOptions) =>
        apiQueryOptions(['followUp', 'getById', data.webinarId, data.followUpId], (api) => api.followUp.getById(data), options),
    getProcessedById: (data: { webinarId: string; followUpId: string }, options?: BaseApiQueryOptions) =>
        apiQueryOptions(['followUp', 'getProcessedById', data.webinarId, data.followUpId], (api) => api.followUp.getProcessedById(data), options),
    addOrUpdate: (options?: BaseApiMutationOptions<ApiClient['followUp']['addOrUpdate']>) => apiMutationOptions((api) => api.followUp.addOrUpdate, options),
    remove: (options?: BaseApiMutationOptions<ApiClient['followUp']['remove']>) => apiMutationOptions((api) => api.followUp.remove, options)
};
